import React from 'react'
import SidebarInf03 from '../../components/sidebar/SidebarInf03'


const Praktykainf3 = () => {
  return (
    <div id='rozwiazaniainf03'>

    <SidebarInf03></SidebarInf03>

        <div id="rozwiazanieustawienie">
          <div id="rozwiazanie" style={{ padding: '20px', maxWidth: '900px', margin: 'auto', textAlign: "left" }}>
            <h1>Skrót Praktyki na INF03</h1>
            <hr></hr>
            <section>
              <h2>W budowie</h2>
              <blockquote class="introduction">
                <strong>Obecnie strona...</strong>
                Ta podstrona jest obecnie w budowie, dlatego nic tu nie znajdziesz. Autor jest zbyt leniwy
                ,aby dodać nowe rzeczy... Jednak z pewnością się tu coś pojawi. Może i jutro? Kto wie.
              </blockquote>
            </section>
           
          </div>
        </div>
    </div>
  )
}

export default Praktykainf3